import { render } from "./PickupLocationSection.vue?vue&type=template&id=63779037&scoped=true"
import script from "./PickupLocationSection.vue?vue&type=script&lang=js"
export * from "./PickupLocationSection.vue?vue&type=script&lang=js"

import "./PickupLocationSection.vue?vue&type=style&index=0&id=63779037&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63779037"]])

export default __exports__